import { EditorAPIKey, EditorCoreApiKey } from '#packages/apis';
import { BaseEntryScope } from '#packages/apilib';

export class StudioMigrationManagerScope extends BaseEntryScope {
  editorCoreAPI = this.useDependency(EditorCoreApiKey);
  editorAPI = this.useDependency(EditorAPIKey);
}
